import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DivestmentStatusDto } from '@cradua/data';
import Swal from 'sweetalert2';


@Component({
  selector: 'cradua-divestmentstatus',
  templateUrl: './divestmentstatus.component.html',
  styleUrls: ['./divestmentstatus.component.scss']
})
export class DivestmentStatusComponent implements OnChanges {


  divestmentstatusForm: FormGroup;
  divestmentstatusFormArray: FormGroup;
  control = new FormControl();
  @Input() divestmentstatuss: DivestmentStatusDto[];
  @Input() routeAnimationsElements: any;
  @Output() divestmentstatus = new EventEmitter<DivestmentStatusDto[]>()
  @Output() deleteDivestmentStatusEvent = new EventEmitter<any>()

    selectedDivestmentStatus: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createDivestmentStatusForm();
    }

    createDivestmentStatusForm() {
      this.divestmentstatusForm = this.fb.group({
        DivestmentStatusName: ['', Validators.required],
        id: null
        });
        this.divestmentstatusFormArray = this.fb.group({ DivestmentStatuss: this.fb.array([])
          });
        this.setDivestmentStatus();
    }

  // method to display divestmentstatuss
  setDivestmentStatus() {
    const control  = this.divestmentstatusFormArray.controls.DivestmentStatuss as FormArray;
    this.divestmentstatuss.forEach( e => {
      control.push(
        this.fb.group({
          DivestmentStatusName: e.DivestmentStatusName,
          id: e.id
        })
      );
    });
  }


  // method to add DivestmentStatus
  addDivestmentStatus(value: DivestmentStatusDto) {
    const control  = this.divestmentstatusFormArray.controls.DivestmentStatuss as FormArray;
    control.insert(0,
          this.fb.group({
            DivestmentStatusName: value.DivestmentStatusName,
            id: null
          })
       );
  }

  selectDivestmentStatus(value) {}

  // method to delete divestmentstatus from arrary list
  deleteDivestmentStatus(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.divestmentstatusFormArray.controls.DivestmentStatuss as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.divestmentstatuss.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.divestmentstatuss[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: DivestmentStatusDto) {
    if(this.divestmentstatusForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.divestmentstatusFormArray.get('DivestmentStatuss')['controls'][this.selectedIndex].patchValue({DivestmentStatusName: formValue.DivestmentStatusName});
    } else {
      this.addDivestmentStatus(formValue);
    }
    this.selectedIndex = null;
    this.divestmentstatusForm.reset()
  }

  onEdit(index, value: DivestmentStatusDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.divestmentstatusForm.patchValue({DivestmentStatusName: value.DivestmentStatusName});
  }

  onClearForm() {
    this.selectedIndex = null;
    this.divestmentstatusForm.reset();
  }

  onSubmit(formValue: DivestmentStatusDto[]) {
  this.divestmentstatus.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteDivestmentStatusEvent.emit(this.filteredDelete);
  }
  }

}
